import { useNavigation } from "@react-navigation/native";
import theme from "assets/theme";
import { getInitials } from "helpers/shared.helpers";
import React, { useContext, useMemo } from "react";
import { Image, Pressable, StyleSheet, Text, View } from "react-native";
import { SCREEN_ACCOUNT_SETTINGS } from "web/constants";
import { AuthContext } from "webContext/Auth.context";
import { OrganizationContext } from "webContext/Organization.context";

const classes = StyleSheet.create({
  organizationImage: {
    height: 45,
    maxWidth: 150,
    width: "auto",
    objectFit: "contain",
  },
  title: {
    fontSize: 24,
    fontWeight: theme.font.weight.medium,
    color: theme.color.grey,
    paddingTop: 16,
  },
  initialText: {
    color: theme.color.grey,
    textAlign: "center",
    fontSize: theme.font.size.subHeader,
    fontWeight: theme.font.weight.semibold,
  },
  profileContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
    cursor: "pointer",
    padding: 8,
    borderRadius: 8,
    transition: "background-color 0.2s",
  },
  userImage: {
    width: "100%",
    height: "100%",
    borderRadius: 200,
    opacity: 0.8,
  },
  userName: {
    color: theme.color.grey,
    fontSize: 20,
  },
});

export default function Header() {
  const {
    isOrganizationLoading,
    organization,
    organizationColor,
    organizationTint,
  } = useContext(OrganizationContext);
  const { userInfo } = useContext(AuthContext);
  const navigation = useNavigation();

  const stateClasses = useMemo(
    () =>
      StyleSheet.create({
        container: {
          width: "100%",
          backgroundColor: organizationColor,
          zIndex: 102,
          shadowColor: "#000",
          shadowOffset: { width: 0, height: 1 },
          shadowOpacity: 0.2,
          shadowRadius: 2,
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: "row",
          padding: 15,
        },
        userImageContainer: {
          width: 35,
          height: 35,
          borderRadius: 200,
          backgroundColor: organizationTint,
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
        },
        profileContainerHover: {
          backgroundColor: `${organizationTint}20`,
        },
      }),
    [organizationColor, organizationTint],
  );

  const contactInitials = useMemo(() => {
    return getInitials(
      `${userInfo.firstName || ""} ${userInfo.lastName || ""}`,
    );
  }, [userInfo]);

  const titleText = useMemo(() => {
    if (isOrganizationLoading && !organization) {
      return "";
    }
    if (!organization) {
      return "Business Continuity Plan";
    } else {
      return organization.name;
    }
  }, [isOrganizationLoading, organization]);

  return (
    <View style={stateClasses.container}>
      {organization?.signedFileUrl ? (
        <img // Uses the native image tag to prevent buggy React Native behavior, cannot be converted to <Image> without changes
          src={organization.signedFileUrl}
          style={classes.organizationImage}
        />
      ) : (
        <Text style={classes.title}>{titleText}</Text>
      )}
      <Text style={classes.title}>Business Continuity Plan</Text>
      <Pressable
        style={({ hovered }) => [
          classes.profileContainer,
          hovered && stateClasses.profileContainerHover,
        ]}
        onPress={() => navigation.navigate(SCREEN_ACCOUNT_SETTINGS)}
      >
        <View style={stateClasses.userImageContainer}>
          {userInfo?.signedFileUrl ? (
            <Image
              source={{ uri: userInfo.signedFileUrl }}
              resizeMode="contain"
              style={classes.userImage}
            />
          ) : (
            <Text style={classes.initialText}>{contactInitials}</Text>
          )}
        </View>
        <Text style={classes.userName}>
          {userInfo?.firstName} {userInfo?.lastName}
        </Text>
      </Pressable>
    </View>
  );
}
